import { FC } from 'react';
import { TextField, TextFieldMask } from 'team-hero-ui';

import type { ITextFieldProps } from './TextModalField.types';
import {
  normalizeString,
  removeWhiteSpaces,
} from 'helpers/string/string.helper';

const TextModalField: FC<ITextFieldProps> = ({
  label,
  onChange,
  value,
  mask,
  type,
  styleType = 'modal',
  hint,
  disabled,
  inputRef,
  removeWhitespace = false,
  multiline,
  minRows,
  maxRows,
  endAdornment,
}) => {
  const onBlur = () => {
    if (value && type !== 'password' && !multiline) {
      onChange(normalizeString(value));
    }
  };

  const onValueChange = (currentValue: string) => {
    if (removeWhitespace && currentValue) {
      onChange(removeWhiteSpaces(currentValue));
    } else {
      onChange(currentValue);
    }
  };

  if (mask) {
    return (
      <TextFieldMask
        label={label}
        value={value}
        onChange={onChange}
        mask={mask}
        styleType={styleType}
        disabled={disabled}
        inputRef={inputRef}
        helperText={hint}
      />
    );
  }

  return (
    <TextField
      label={label}
      value={value}
      onChange={onValueChange}
      styleType={styleType}
      type={type}
      helperText={hint}
      disabled={disabled}
      onBlur={onBlur}
      inputRef={inputRef}
      multiline={multiline}
      minRows={minRows}
      maxRows={maxRows}
      endAdornment={endAdornment}
    />
  );
};

export default TextModalField;
